import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {DepotService} from "../../services/depot-service/depot.service";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {ApolloQueryObservable} from "apollo-angular";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {AbstractControl} from '@angular/forms';
import {DepotYard} from '../../../shared/view-model/store-management/depot-yard.type';

@Component({
  selector: 'vb-depot-list-view',
  templateUrl: './depot-list-view.component.html',
  styleUrls: ['./depot-list-view.component.css']
})
export class DepotListViewComponent extends AbstractVisbosComponent implements OnInit, AfterViewChecked {


  depots$: ApolloQueryObservable<Depot[]>;
  depots: Depot[];

  @ViewChild('addDepotModal')
  addDepotModal: GenericModalComponent;

  @ViewChild('editDepotModal')
  editDepotModal: GenericModalComponent;

  @ViewChild('editDepotYardModal')
  editDepotYardModal: GenericModalComponent;

  showDepotInfo: boolean = false;

  currentDepot: Depot;
  currentDepotForm: AbstractControl;

  currentDepotYard: DepotYard;
  currentDepotYardForm: AbstractControl;

  constructor(sessionActions: SessionActions, private depotService: DepotService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Neues Lager anlegen', icon: 'fa-plus', action: () => {
          this.showAddDepotModal.apply(this)
        }
      }
    ];

  }

  showAddDepotModal() {
    this.addDepotModal.show();
  }

  ngOnInit() {
    this.depots$ = this.depotService.getDepotsList(this.activeAdminUnitCuid$);
    this.addComponentData(this.depots$);
    this.dataSubscriptions.push(this.depots$.subscribe((res: any) => {
      this.depots = res;
    }));
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  addDepot(depotData) {
    this.depotService.addDepot(depotData).toPromise()
      .then((res: any) => {
        this.depots$.refetch();
      })
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Anlegen des Lagers: " + err.message));
    this.currentDepotForm = null;
    this.currentDepot = null;
  }

  deleteDepot(cuid: string) {
    this.depotService.deleteDepot(cuid).toPromise()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen des Lagers: " + err.message));
  }

  onEditDepotClicked(depot: Depot) {
    this.currentDepot = depot;
    this.editDepotModal.show();
    this.cd.detectChanges();
  }

  editDepot(cuid: string, depotData) {
    this.depotService.editDepot(cuid, depotData).toPromise()
      .then(res => {
        this.currentDepot = null;
        this.currentDepotForm = null;
      })
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Bearbeiten des Lagers: " + err.message));
  }

  addDepotYard(depotCuid: string, depotYardData) {
    this.depotService.addDepotYard(depotYardData, depotCuid).toPromise()
      .then((res: any) => {
        this.currentDepotYard = null;
        this.currentDepotYardForm = null;
        this.depots$.refetch();
      })
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Anlegen des Lagerplatzes: " + err.message));
  }

  onEditDepotYardClicked(depotYard: DepotYard) {
    this.currentDepotYard = depotYard;
    this.currentDepotYardForm = null;
    this.editDepotYardModal.show();
    this.cd.detectChanges();
  }

  editDepotYard(cuid: string, depotYardData) {
    this.depotService.editDepotYard(cuid, depotYardData).toPromise()
      .then(res => {
        this.currentDepotYard = null;
        this.currentDepotYardForm = null;
      })
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Bearbeiten des Lagerplatzes: " + err.message));
  }

  deleteDepotYard(cuid: string) {
    this.depotService.deleteDepotYard(cuid).toPromise()
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen des Lagerplatzes: " + err.message));
    this.depots$.refetch();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/depot/depot-list-view/depot-list-view.component.ts